import { render, staticRenderFns } from "./PdfListStudents.vue?vue&type=template&id=2dd5761a&"
import script from "./PdfListStudents.vue?vue&type=script&lang=js&"
export * from "./PdfListStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports